import {makeObservable, observable} from "mobx";

export class ProfileFeature {
    constructor() {
        // TODO: Replace this with the actual data retrieved by the backend.
        this._profileInformation = {
            PedidoInicial: {
                UsuarioCliente: {
                    Email: 'john.doe@gmail.com',
                    Nombre: 'John',
                    Apellido: 'Doe',
                    EsAdministrador: true,
                    EsGerenteSucursal: true
                },
                Cliente: {
                    Nombre: 'Sapore',
                    RazonSocial: '123'
                }
            },
            PuntosEntregaUsuarioActual: [
                {
                    NombreYDireccion: 'Cabildo 123'
                }
            ],
            Usuarios: [
                {
                    Id: 1,
                    NombreYApellido: 'JohnnyDoe',
                    EsAdministrador: true,
                    EsGerenteSucursal: true
                }
            ],
            PuntosEntrega: [
                {
                    Id: 1,
                    Nombre: 'Deposito 123',
                    Direccion: 'Corrientes 123',
                    Localidad: 'CABA'
                }
            ]
        }

        this._loaded = true

        makeObservable(this, {
            _profileInformation: observable,
            _loaded: observable
        })
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }

    isAdministrator() {
        return this._profileInformation.PedidoInicial.UsuarioCliente.EsAdministrador;
    }

    isBranchManager() {
        return this._profileInformation.PedidoInicial.UsuarioCliente.EsGerenteSucursal;
    }

    get email() {
        return this._profileInformation.PedidoInicial.UsuarioCliente.Email;
    }

    get name() {
        return this._profileInformation.PedidoInicial.UsuarioCliente.Nombre;
    }

    get lastname() {
        return this._profileInformation.PedidoInicial.UsuarioCliente.Apellido;
    }

    get socialReason() {
        return this._profileInformation.PedidoInicial.Cliente.RazonSocial;
    }

    deliverySitesForCurrentUser() {
        return this._profileInformation.PuntosEntregaUsuarioActual;
    }

    get users() {
        return this._profileInformation.Usuarios;
    }

    get deliverySites() {
        return this._profileInformation.PuntosEntrega;
    }
}